/**
 * featureFlags.js
 *
 * Per-business feature flags for the automation editor.
 *
 * Flags are read from `businessData.features` (BOS business document) with a
 * hardcoded pilot fallback (the two businesses already allowed to edit
 * automations).
 *
 * Rollout (plan section L): pilot UIDs → features.automationMappingV2 per
 * business → default on with features opt-out. The mapping experience has
 * reached the last stage; `automationsEdit` is still pilot-gated.
 */

export const AUTOMATION_PILOT_BUSINESS_UIDS = [
  'kIb0dHh5Mtdg5U5Eda7NFHk2cL83',
  'v3yIfTXpDgYRUaMn3u27SthdozW2',
];

const isPilotBusiness = (currentUser) =>
  AUTOMATION_PILOT_BUSINESS_UIDS.includes(currentUser?.activeBusiness?.uid);

/**
 * Whether the automations section is editable for this business.
 * Generalized from the previous hardcoded-UID check: an explicit
 * businessData.features.automationsEdit === true also enables it.
 */
// This only reveals editor controls; authorization remains enforced by the API.
export const isAutomationDevelopmentHost = (
  hostname = typeof window === 'undefined' ? '' : window.location.hostname
) => ['dev.usenode.com', 'localhost', '127.0.0.1', '::1', '[::1]'].includes(hostname);

export const isAutomationEditAllowed = (currentUser, businessData, hostname) =>
  businessData?.features?.automationsEdit === true || isPilotBusiness(currentUser) ||
  isAutomationDevelopmentHost(hostname);

/**
 * Whether the new guided mapping experience (structured parameter selector,
 * chips value editor, data catalog…) is enabled. ON by default; a business
 * opts out with features.automationMappingV2 === false, which restores the
 * legacy free-text editor.
 */
export const isAutomationMappingV2Enabled = (currentUser, businessData) =>
  businessData?.features?.automationMappingV2 !== false;
